import { Link } from 'react-router-dom';
import { Instagram, Facebook, Linkedin, Twitter } from 'lucide-react';
import { openCookiePreferences } from '@/lib/consent';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://res.cloudinary.com/dzk6j0kr2/image/upload/v1784037648/gn-management/brand/gn_logo.png"
              alt="GN Management"
              className="h-16 mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Building resilient, design-forward communities since 2015.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#20B2AA]">Quick Links</h3>
            <ul className="space-y-2">
              {[
                { name: 'About Us', path: '/about' },
                { name: 'Portfolio', path: '/portfolio' },
                { name: 'Services', path: '/services' },
                { name: 'News', path: '/news' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-[#20B2AA] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#20B2AA]">Services</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Real Estate Investment</li>
              <li>Property Management</li>
              <li>Construction Services</li>
              <li>Development Consulting</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#20B2AA]">Get in Touch</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>30 Hudson St</li>
              <li>Jersey City, NJ 07302</li>
              <li className="pt-2">
                <span className="text-gray-500">General:</span>{' '}
                <a href="mailto:inquiry@gnmgt.com" className="hover:text-[#20B2AA] transition-colors">inquiry@gnmgt.com</a>
              </li>
              <li>
                <span className="text-gray-500">Rentals:</span>{' '}
                <a href="mailto:support@gnmgt.com" className="hover:text-[#20B2AA] transition-colors">support@gnmgt.com</a>
              </li>
              <li>
                <span className="text-gray-500">Investment:</span>{' '}
                <a href="mailto:info@gnmgt.com" className="hover:text-[#20B2AA] transition-colors">info@gnmgt.com</a>
              </li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a
                href="https://www.instagram.com/gnmanagement_developers/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-[#20B2AA] rounded-full flex items-center justify-center transition-all duration-200 hover:-translate-y-1"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href="https://www.facebook.com/GNmanagementINC"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-[#20B2AA] rounded-full flex items-center justify-center transition-all duration-200 hover:-translate-y-1"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href="https://www.linkedin.com/company/gnmanagementinc/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-[#20B2AA] rounded-full flex items-center justify-center transition-all duration-200 hover:-translate-y-1"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              <a
                href="https://x.com/GnManagement"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-[#20B2AA] rounded-full flex items-center justify-center transition-all duration-200 hover:-translate-y-1"
              >
                <Twitter className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Copyright - Left */}
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} GN Management Inc. All rights reserved.
            </p>

            {/* Legal links - Center */}
            <div className="flex items-center gap-4 text-gray-400 text-sm">
              <Link to="/privacy" className="hover:text-[#20B2AA] transition-colors" data-testid="footer-privacy-link">
                Privacy Policy
              </Link>
              <span className="text-gray-600">|</span>
              <Link to="/cookies" className="hover:text-[#20B2AA] transition-colors" data-testid="footer-cookie-link">
                Cookie Policy
              </Link>
              <span className="text-gray-600">|</span>
              <button
                onClick={openCookiePreferences}
                className="hover:text-[#20B2AA] transition-colors"
                data-testid="footer-cookie-prefs-btn"
              >
                Cookie Preferences
              </button>
            </div>
            
            {/* Designed by - Right */}
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <span>Designed and developed by</span>
              <a 
                href="https://corsnova.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center hover:opacity-80 transition-opacity duration-200"
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_property-admin-22/artifacts/xjn7t5ec_corsnova%20white%20logo.png" 
                  alt="Corsnova" 
                  className="h-5"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
